/* eslint-disable
    eqeqeq,
    no-use-before-define,
    no-var,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS104: Avoid inline assignments
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const $ = require('jquery');
const { TrelloStorage } = require('@trello/storage');
const _ = require('underscore');

module.exports = window.Logger = new (class {
  constructor() {
    let left;
    this.enabled = (left = TrelloStorage.get('loggers')) != null ? left : {};
    this.historyMap = {};
    this.logHistory = false;
    this.timeSpent = {};
    this.timing = {};
  }

  log(region, ...args) {
    if (
      !(typeof console !== 'undefined' && console !== null
        ? console.log
        : undefined)
    ) {
      return;
    }

    let isRegionEnabled = false;

    if (args.length === 0) {
      isRegionEnabled = true;
      args.push(region);
      region = 'all';
    } else {
      isRegionEnabled = this.enabled['all'] || this.enabled[region];
    }

    if (isRegionEnabled) {
      if (args.length === 1 && _.isArray(args[0])) {
        args = args[0];
      }

      args.unshift(region);
      args.unshift(new Date());
      if ($('#trello-root').is('.chrome')) {
        console.log(args);
      } else {
        console.dir(args);
      }
    }

    if (this.logHistory) {
      if (this.historyMap[region] == null) {
        this.historyMap[region] = [];
      }
      this.historyMap[region].push(args);
    }
  }

  enable(region) {
    if (region == null) {
      region = 'all';
    }
    this.enabled[region] = true;
    this.save();
  }

  disable(region) {
    if (region == null) {
      region = 'all';
    }
    delete this.enabled[region];
    this.save();
  }

  disableAll() {
    this.enabled = {};
    this.save();
  }

  enableAll() {
    this.enabled['all'] = true;
    this.save();
  }

  history(region) {
    if (region in this.historyMap) {
      for (var args of Array.from(this.historyMap[region])) {
        __guardMethod__(console, 'log', (o) => o.log(args));
      }
    }
  }

  list() {
    __guardMethod__(console, 'log', (o) => o.log(_.keys(this.historyMap)));
  }

  save() {
    TrelloStorage.set('loggers', this.enabled);
  }

  time(name) {
    return (this.timing[name] = performance.now());
  }

  endTime(name) {
    const delta = performance.now() - this.timing[name];
    if (this.timeSpent[name] == null) {
      this.timeSpent[name] = 0;
    }
    return (this.timeSpent[name] += delta);
  }
})();

function __guardMethod__(obj, methodName, transform) {
  if (
    typeof obj !== 'undefined' &&
    obj !== null &&
    typeof obj[methodName] === 'function'
  ) {
    return transform(obj, methodName);
  } else {
    return undefined;
  }
}
